import imageOne from '@/assets/images/cities/ajax1.jpg'
import imageTwo from '@/assets/images/cities/ajax2.jpg'
import imageThree from '@/assets/images/cities/ajax3.jpg'

export default {
  imageOne,
  imageTwo,
  imageThree,
  city: 'Ajax',
  writeup: '',
  website: 'AjaxNotaryPublic.com',
  url: 'https://www.ajaxnotarypublic.com/',
  notaries: [
    {
      name: '',
      open: true,
      phone: '',
      hours: {
        monday: '9:00AM to 5:00PM',
        tuesday: '9:00AM to 5:00PM',
        wednesday: '9:00AM to 5:00PM',
        thursday: '9:00AM to 5:00PM',
        friday: '9:00AM to 5:00PM',
        saturday: 'Closed',
        sunday: 'Closed'
      },
      address: '467 Westney Road S. Location',
      notes: ''
    }
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontarioGTA/cities/ajax.js